/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AustraliaInputs */

const en_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia`)
};

const es_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia`)
};

const fr_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australie`)
};

const de_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australien`)
};

const ja_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーストラリア`)
};

const zh_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`澳大利亚`)
};

const ar_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أستراليا`)
};

const id_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia`)
};

const it_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia`)
};

const ru_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Австралия`)
};

const pt_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Austrália`)
};

const ko_australia = /** @type {(inputs: AustraliaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`호주`)
};

/**
* | output |
* | --- |
* | "Australia" |
*
* @param {AustraliaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const australia = /** @type {((inputs?: AustraliaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AustraliaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_australia(inputs)
	if (locale === "es") return es_australia(inputs)
	if (locale === "fr") return fr_australia(inputs)
	if (locale === "de") return de_australia(inputs)
	if (locale === "ja") return ja_australia(inputs)
	if (locale === "zh") return zh_australia(inputs)
	if (locale === "ar") return ar_australia(inputs)
	if (locale === "id") return id_australia(inputs)
	if (locale === "it") return it_australia(inputs)
	if (locale === "ru") return ru_australia(inputs)
	if (locale === "pt") return pt_australia(inputs)
	return ko_australia(inputs)
});